module.exports = __webpack_public_path__ + "img/hic-lung-cancer-female.5557e576.png";